export const MUI_X_LICENSE_KEY =
  '1cfe5596c1b8966a09a3a2cab2082d14Tz0xMzIwMjksRT0xODE4ODA2Mzk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEwLEFUPW11bHRpLEtWPTI=';
